
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8 12.052a24.19 24.19 0 01-1.768-.315c-1.788-.39-3.199-.963-4.232-1.723v2.306c0 .624.447 1.202 1.341 1.736.894.533 2.11.956 3.646 1.268.331.067.67.127 1.013.18v-3.452zm0-1.756a21.303 21.303 0 01-1.013-.18c-1.536-.312-2.752-.735-3.646-1.268C2.447 8.314 2 7.736 2 7.112v-.64c0-.624.447-1.202 1.341-1.736.894-.533 2.11-.954 3.646-1.261C8.523 3.158 10.194 3 12 3s3.477.156 5.013.468c1.536.312 2.752.735 3.646 1.268C21.553 5.27 22 5.848 22 6.472V7H9a1 1 0 00-1 1v2.296zm0 6.964v3.452a21.43 21.43 0 01-1.013-.18c-1.536-.312-2.752-.735-3.646-1.268C2.447 18.73 2 18.152 2 17.528v-2.306c1.033.76 2.444 1.334 4.232 1.723.575.125 1.165.23 1.768.315z","fill":"#454C52"}}),_c('path',{attrs:{"d":"M16.045 15.045H10V9h6.045v6.045z","fill":"#F1511B"}}),_c('path',{attrs:{"d":"M23 15.045h-6.046V9H23v6.045z","fill":"#80CC28"}}),_c('path',{attrs:{"d":"M16.046 22H10v-6.046h6.046v6.045z","fill":"#00ADEF"}}),_c('path',{attrs:{"d":"M23 22h-6.046v-6.046H23v6.045z","fill":"#FBBC09"}})])
          )
        }
      }
    